const DEFAULT_STATE = {
  now: {
    today: '2024-08-28',
    currentWeek: 35,
  },
}

export default DEFAULT_STATE
